var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-order__order" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-primary order__btn order-btn",
        on: {
          click: function ($event) {
            _vm.dropdownForm = true
          },
        },
      },
      [
        _c("i", {
          staticClass: "bi bi-bag-plus order-btn__icon order-btn__icon--cart",
        }),
        _vm._v(" В корзину\n  "),
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-outline-primary order__btn",
        attrs: {
          "data-bs-toggle": "modal",
          "data-bs-target": "#mainModal",
          "data-bs-mtitle": "Заказать прайс-лист",
          "data-bs-mtext":
            "Напишите, какая продукция и объем вас интересует. Расскажите о своей компании и потребностях, чтобы мы подготовили индивидуальный прайс-лист",
        },
      },
      [
        _c("i", { staticClass: "btn__icon btn__icon--excel" }, [
          _c(
            "svg",
            {
              staticClass: "bi bi-file-earmark-excel",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "currentColor",
                viewBox: "0 0 16 16",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" Прайс\n  "),
      ]
    ),
    _vm._v(" "),
    _vm.dropdownForm
      ? _c(
          "div",
          {
            staticClass:
              "dropdown-menu show product-order__dropdown product-order-menu",
          },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-dark close product-order-menu__close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.dropdownForm = false
                  },
                },
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
            _vm._v(" "),
            _vm.step == "add-btn"
              ? _c("div", [
                  _c("div", { staticClass: "product-order-menu__title" }, [
                    _vm._v("Выбрать фасовку"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "order-form__form-group",
                      class: {
                        "order-form__form-group--danger": _vm.errors.product,
                      },
                    },
                    [
                      _vm.productInstance
                        ? _c(
                            "ul",
                            {
                              staticClass:
                                "product-order-menu__variants product-variants",
                            },
                            _vm._l(
                              _vm.productInstance.packages,
                              function (variant) {
                                return _c(
                                  "li",
                                  {
                                    key: "variant_" + variant.id,
                                    staticClass:
                                      "product-variants__item variant-radio",
                                    class: {
                                      "variant-radio--active":
                                        _vm.cartItem.object_id == variant.id,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.set_cart_item(variant)
                                      },
                                    },
                                  },
                                  [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.cartItem.object_id,
                                            expression: "cartItem.object_id",
                                          },
                                        ],
                                        staticClass: "product-variants__radio",
                                        attrs: {
                                          type: "radio",
                                          name: "product_variants",
                                        },
                                        domProps: {
                                          value: variant.id,
                                          checked: _vm._q(
                                            _vm.cartItem.object_id,
                                            variant.id
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.cartItem,
                                              "object_id",
                                              variant.id
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(variant.package_title)
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.product
                        ? _c("p", { staticClass: "order-form__help" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.product.join(", ")) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "product-order-menu__form order-form" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "order-form__form-group",
                          class: {
                            "order-form__form-group--danger":
                              _vm.errors.unit_quantity,
                          },
                        },
                        [
                          _c("label", { staticClass: "order-form__label" }, [
                            _vm._v("Количество:"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cartItem.unit_quantity,
                                expression: "cartItem.unit_quantity",
                              },
                            ],
                            staticClass: "order-form__input",
                            attrs: { type: "text" },
                            domProps: { value: _vm.cartItem.unit_quantity },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.cartItem,
                                  "unit_quantity",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.unit_quantity
                            ? _c("p", { staticClass: "order-form__help" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.errors.unit_quantity.join(", ")
                                    ) +
                                    "\n          "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-form__buttons" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-info order-form__btn order-form__btn--add",
                            on: {
                              click: function ($event) {
                                return _vm.addToCartDropdown()
                              },
                            },
                          },
                          [_vm._v("В заказ")]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step == "cart-btn"
              ? _c("div", { staticClass: "dropdown-menu__result" }, [
                  _c("p", { staticClass: "text-success" }, [
                    _vm._v("Добавлено в корзину."),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary me-1",
                        attrs: { href: "/cart/" },
                      },
                      [_vm._v("Оформить")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-dark ms-1",
                        on: {
                          click: function ($event) {
                            _vm.dropdownForm = false
                          },
                        },
                      },
                      [_vm._v("Закрыть")]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }